import { Instagram, Facebook, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { GALLERY, INSTAGRAM_URL, INSTAGRAM_HANDLE, FACEBOOK_URL } from "../lib/site";

const previews = [GALLERY[1], GALLERY[3], GALLERY[4]];

export default function InstagramSection() {
  return (
    <section className="py-24 md:py-28 bg-brand-deep grain relative overflow-hidden" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <SectionTag dark>Instagram</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08] text-balance">
            Acompanhe os passeios <span className="font-serif italic font-medium text-accent-soft">de pertinho</span>
          </h2>
          <p className="mt-6 text-white/75 text-base md:text-lg leading-relaxed max-w-lg">
            Bastidores, grupos na Sprinter, dicas de Foz do Iguaçu e registros reais de cada experiência na Tríplice Fronteira — tudo lá no Instagram.
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta-button"
            className="group mt-9 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-sm font-bold text-brand-deep shadow-2xl transition-transform duration-300 hover:scale-[1.04]"
          >
            <span className="grid place-items-center w-8 h-8 rounded-full bg-gradient-to-tr from-amber-400 via-pink-500 to-purple-600 text-white">
              <Instagram size={16} />
            </span>
            Seguir {INSTAGRAM_HANDLE}
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="facebook-cta-button"
            className="group mt-4 inline-flex items-center gap-3 rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-white/20"
          >
            <span className="grid place-items-center w-8 h-8 rounded-full bg-[#1877F2] text-white">
              <Facebook size={16} />
            </span>
            Curtir no Facebook
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="grid grid-cols-3 gap-3 md:gap-4" data-testid="instagram-preview-grid">
            {previews.map((p, i) => (
              <a
                key={p.img}
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-preview-${i}`}
                className={`group relative block overflow-hidden rounded-2xl aspect-[3/4] ${i === 1 ? "translate-y-6" : ""}`}
              >
                <img src={p.img} alt={p.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-brand-deep/0 transition-colors duration-500 group-hover:bg-brand-deep/30" />
                <span className="absolute top-3 right-3 grid place-items-center w-8 h-8 rounded-full bg-white/20 backdrop-blur text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <Instagram size={14} />
                </span>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
